<template>
  <div class="qr-container">
    <div class="qr-box">
      <qrcode-vue :value="value" :size="size" :level="level" class="qr-code" />
      <img v-if="logoSrc" :src="logoSrc" alt="QR Logo" class="qr-logo" />
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    QrcodeVue,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 300,
    },
    level: {
      type: String,
      default: 'H',
    },
    logoSrc: {
      type: String,
      default: () => require('@/assets/logo/small-logo.svg'),
    },
  },
}
</script>

<style scoped>
.qr-container {
  text-align: center;
}

.qr-box {
  position: relative;
  display: inline-block;
  padding: 10px;
  background: #fff;
  border-radius: 12px;
}

.qr-code {
  border: 8px solid #fff;
  border-radius: 12px;
}

.qr-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 1px 0;
  border-radius: 12px;
}
</style>
